"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const native_1 = require("@react-navigation/native");
const useAppNavigation = () => (0, native_1.useNavigation)();
exports.default = useAppNavigation;
